/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgencyGroupResponse
 */
export interface AgencyGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupResponse
     */
    agencyGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupResponse
     */
    agencyGroupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupResponse
     */
    agencyGroupDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyGroupResponse
     */
    brand?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupResponse
     */
    market?: string | null;
}

export function AgencyGroupResponseFromJSON(json: any): AgencyGroupResponse {
    return AgencyGroupResponseFromJSONTyped(json, false);
}

export function AgencyGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencyGroupId': !exists(json, 'agencyGroupId') ? undefined : json['agencyGroupId'],
        'agencyGroupName': !exists(json, 'agencyGroupName') ? undefined : json['agencyGroupName'],
        'agencyGroupDescription': !exists(json, 'agencyGroupDescription') ? undefined : json['agencyGroupDescription'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'market': !exists(json, 'market') ? undefined : json['market'],
    };
}

export function AgencyGroupResponseToJSON(value?: AgencyGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencyGroupId': value.agencyGroupId,
        'agencyGroupName': value.agencyGroupName,
        'agencyGroupDescription': value.agencyGroupDescription,
        'brand': value.brand,
        'market': value.market,
    };
}


